import React, { useState, useEffect } from 'react';

interface AreaData {
    cursuerNameZh: string;
    cursuerNameEn: string;
    detailZh: string;
    detailEn: string;
    zipCode: string;
    phone: string;
    areaNameZh: string;
    areaNameEn: string;
}

interface ChooseListItem {
    areaNameZh: string;
    areaNameEn: string;
    areaList: AreaData[];
}

// 模拟数据（中英文）
const mockAreaData: AreaData[] = [
    {
        cursuerNameZh: '上海办公室',
        cursuerNameEn: 'Shanghai Office',
        detailZh: '虹口区四川北路88号星荟中心1座3101',
        detailEn: 'Star Center Building 1, 3101, Sichuan North Road, Hongkou District, Shanghai',
        zipCode: '200120',
        phone: '****-*********',
        areaNameZh: '上海',
        areaNameEn: 'Shanghai'
    },
    {
        cursuerNameZh: '新加坡办公室',
        cursuerNameEn: 'Singapore Office',
        detailZh: 'Phillip Street, #19–02 Royal Group Building Singapore 048693',
        detailEn: 'Phillip Street, #19–02 Royal Group Building Singapore 048693',
        zipCode: '510623',
        phone: '****-**********',
        areaNameZh: '新加坡',
        areaNameEn: 'Singapore'
    },
];

const AboutPart2: React.FC = () => {
    const themeColor = '#ac9455';
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [chooseList, setChooseList] = useState<ChooseListItem[]>([]);

    useEffect(() => {
        const processedList: ChooseListItem[] = mockAreaData.reduce(
            (acc: ChooseListItem[], row: AreaData) => {
                const exist = acc.find(item => item.areaNameZh === row.areaNameZh);
                if (exist) {
                    exist.areaList.push(row);
                } else {
                    acc.push({
                        areaNameZh: row.areaNameZh,
                        areaNameEn: row.areaNameEn,
                        areaList: [row]
                    });
                }
                return acc;
            },
            []
        );
        setChooseList(processedList);
    }, []);

    const switchTab = (index: number) => {
        setSelectedIndex(index);
    };

    return (
        <div className="about-part2">
            <div className="aboutpart1-header">
                {languageCode === 'zh' ? '办公地址' : 'Office Address'}
            </div>

            {/* 顶部地区切换 */}
            <div className="aboutchoose">
                {chooseList.map((item, index) => (
                    <div
                        key={index}
                        className={`aboutchoose-item ${index === selectedIndex ? 'selected' : ''}`}
                        onClick={() => switchTab(index)}
                        style={{ borderBottomColor: themeColor }}
                    >
                        {languageCode === 'zh' ? item.areaNameZh : item.areaNameEn}
                    </div>
                ))}
            </div>

            {/* 对应内容 */}
            {chooseList.map((item, index) => (
                <div
                    key={index}
                    className={`about-content ${index === selectedIndex ? 'show' : 'hide'}`}
                >
                    {item.areaList.map((detail, idx) => (
                        <div className="about-content-item" key={idx}>
                            <div className="about-item-name">
                                {languageCode === 'zh' ? detail.cursuerNameZh : detail.cursuerNameEn}
                            </div>
                            <div className="about-item-details">
                                {languageCode === 'zh' ? detail.detailZh : detail.detailEn}
                            </div>
                            <div className="about-item-details">{detail.zipCode}</div>
                        </div>
                    ))}
                </div>
            ))}

            <div style={{ height: '82px' }}></div>
        </div>
    );
};

export default AboutPart2;
